<template>
  <b-container>
    <h1>Learn</h1>

    <div class="mb-5 mx-auto w-75">
      <p class="p-up">
        Best practices, webinars, courses, forums and more. Learn how to do great
        citizen science by drawing on our CitSci knowledge base.
      </p>
    </div>

    <h2>Best Practices</h2>
    <p>We've been fortunate enough to form relationships with some of the best
      citizen science projects out there. And they have taught us much about what
      works and what doesn't. Plus - we've studied the science of citizen science
      for 10+ years now leading to some
      <b-link to="publications">publications</b-link>
      of our own and new knowledge. We're happy to pass along anything we've
      learned through these experiences by sharing what we've picked up along
      the way.
<!--      <b-link to="newsletter">Sign up for our newsletter</b-link>-->
<!--      to-->
<!--      learn more.-->
      </p>

<!--        <h2>Webinars</h2>-->
<!--        <p>We periodically host-->
<!--          <b-link to="webinars">webinars</b-link>-->
<!--          to help-->
<!--          you do great citizen science. We sometimes host these through the-->
<!--          <IconLink-->
<!--            href="https://www.citizenscience.org/" target="NewWindow">Citizen Science-->
<!--            Association-->
<!--          </IconLink>-->
<!--          . Topics-->
<!--          range from highlighting your projects and lessons learned to data management-->
<!--          to best practices. Stay tuned. More details coming soon.-->
<!--        </p>-->

        <h2>Courses</h2>
        <p>Our team often teaches classes on citizen science at both the graduate and
          undergraduate level at
          <IconLink href="https://www.colostate.edu/" target="NewWindow">
            Colorado State University
          </IconLink>
          Feel
          free to
          <b-link to="contact">Contact Us</b-link>
          anytime to learn more.
        </p>

        <h2>Forums</h2>
        <p>Check out our many project forums and ask questions from the best of the best.
          CitSci project managers are often happy to help you with your citizen science
          related questions. Drop them a line to learn from our community.</p>
<!--    Stay tuned also for details about our general community forum we hope to launch in 2021.-->

  </b-container>
</template>

<script>
import IconLink from '../../components/layout/IconLink.vue';

export default {
  components: [IconLink]
}
</script>
